export default {
  hero: {
    title: "Privacy Policy"
  },
  toc: {
    title: "Contents"
  },
  sections: [
    {
      id: "section1",
      title: "1 Controller",
      blocks: [
        "The controller responsible for data processing on this platform is:\n\nEat&Drink 7day GmbH\nFrauenfelderstrasse 4\n8252 Schlatt\nSwitzerland"
      ]
    },
    {
      id: "section2",
      title: "2 General Information",
      blocks: [
        "This Privacy Policy explains how personal data is collected, processed, and used in connection with the use of NutriBot.",
        "By using the platform, the user acknowledges and accepts the data processing as described in this Privacy Policy."
      ]
    },
    {
      id: "section3",
      title: "3 Categories of Data Processed",
      blocks: [
        "The following categories of personal data may be processed:",
        "**3.1 Account Data**",
        [
          "Name",
          "Email address",
          "Login credentials"
        ],
        "**3.2 Usage Data**",
        [
          "User inputs and generated content",
          "Interactions with the platform",
          "Usage behavior"
        ],
        "**3.3 Health-Related Data**",
        [
          "Body weight",
          "Body height",
          "Voluntarily provided nutrition-related or body-related information"
        ],
        "Such data may allow conclusions about the user's health status.",
        "**3.4 Technical Data**",
        [
          "IP address",
          "device type",
          "browser type",
          "operating system",
          "timestamps"
        ],
        "**3.5 Payment Data**",
        [
          "billing information",
          "subscription status"
        ],
        "Payment data is processed via third-party payment providers."
      ]
    },
    {
      id: "section4",
      title: "4 Purpose of Processing",
      blocks: [
        "Personal data is processed for the following purposes:",
        [
          "providing and operating the platform",
          "generating content",
          "improving system performance and functionality",
          "ensuring security and preventing misuse",
          "processing payments and subscriptions",
          "complying with legal obligations"
        ]
      ]
    },
    {
      id: "section5",
      title: "5 Legal Basis",
      blocks: [
        "Processing is based on:",
        [
          "performance of a contract",
          "legitimate interests",
          "compliance with legal obligations"
        ],
        "Health-related data is processed exclusively on the basis of the user’s explicit consent.",
        "The provision of such data is voluntary."
      ]
    },
    {
      id: "section6",
      title: "6 Data Sharing",
      blocks: [
        "Personal data may be shared with:",
        [
          "hosting providers",
          "payment service providers",
          "analytics and tracking providers",
          "IT and security service providers"
        ],
        "Data is shared only to the extent necessary for operating the platform."
      ]
    },
    {
      id: "section7",
      title: "7 International Data Transfers",
      blocks: [
        "Data may be transferred to countries outside Switzerland or the European Economic Area.",
        "In such cases, appropriate safeguards are implemented, including:",
        [
          "standard contractual clauses",
          "equivalent legal protection mechanisms"
        ]
      ]
    },
    {
      id: "section8",
      title: "8 Data Retention",
      blocks: [
        "Personal data is retained only as long as necessary for:",
        [
          "providing the service",
          "fulfilling legal obligations",
          "enforcing or defending legal claims"
        ]
      ]
    },
    {
      id: "section9",
      title: "9 Data Security",
      blocks: [
        "Appropriate technical and organizational measures are implemented to protect data against:",
        [
          "unauthorized access",
          "loss",
          "misuse",
          "alteration"
        ],
        "However, absolute security cannot be guaranteed."
      ]
    },
    {
      id: "section10",
      title: "10 User Rights",
      blocks: [
        "Users may have the following rights under applicable law:",
        [
          "access to personal data",
          "correction of inaccurate data",
          "deletion of data",
          "restriction of processing",
          "data portability",
          "objection to processing"
        ],
        "Requests may be directed to the controller."
      ]
    },
    {
      id: "section11",
      title: "11 Automated Processing",
      blocks: [
        "NutriBot uses automated systems, including artificial intelligence.",
        "No legally binding decisions are made solely based on automated processing."
      ]
    },
    {
      id: "section12",
      title: "12 Cookies and Tracking",
      blocks: [
        "The platform may use cookies and similar technologies for:",
        [
          "functionality",
          "analytics",
          "performance optimization"
        ],
        "Users can manage cookie settings via their browser or consent mechanisms."
      ]
    },
    {
      id: "section13",
      title: "13 Third-Party Services",
      blocks: [
        "The platform may integrate third-party services.",
        "These providers may process data independently under their own privacy policies."
      ]
    },
    {
      id: "section14",
      title: "14 Handling of Health-Related Data",
      blocks: [
        "Health-related data is:",
        [
          "used solely to provide platform functionality",
          "not used for medical purposes",
          "not used to create medical profiles"
        ],
        "The user expressly acknowledges:",
        [
          "that providing such data is voluntary",
          "that no medical evaluation is performed",
          "that use is at the user’s own risk"
        ]
      ]
    },
    {
      id: "section15",
      title: "15 Changes",
      blocks: [
        "This Privacy Policy may be updated at any time.",
        "The current version is binding."
      ]
    },
    {
      id: "section16",
      title: "16 Contact",
      blocks: [
        "For any privacy-related inquiries:\n\nEat&Drink 7day GmbH\nFrauenfelderstrasse 4\n8252 Schlatt\nSwitzerland"
      ]
    }
  ],
  finalStatement: "Final Statement\n\nUse of NutriBot requires the processing of personal data, which is technically necessary for the operation of the platform and cannot be waived."
};